import axios from 'axios';
const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const updatePassword = (data: any) => {
    return axios.put(`${API_URL}users/updatePassword`, data);
}



export const API = {
    updatePassword
}